import { AuthContext } from '@repo-level/core-front';
import diamond1 from 'assets/images/crystal/diamond-1.webp';
import diamond2 from 'assets/images/crystal/diamond-2.webp';
import menuBg from 'assets/images/crystal/menu-bg.webp';
import { ImageComponent } from 'components/Image';
import { useTheme } from 'hooks/theme';
import { useAuroraCrystalLogic } from 'modules/crystal/hooks';
import type { FC } from 'react';
import { memo, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigation } from 'react-navi';
import { ScAuroraPanel } from './styled';

export interface IAuroraPanelProps {
  onLinkClick?: () => void;
}

export const AuroraPanel: FC<IAuroraPanelProps> = memo(({ onLinkClick }) => {
  const { t } = useTranslation(['crystal']);

  const { isAuthenticated } = useContext(AuthContext);

  const { images } = useTheme();

  const { navigate } = useNavigation();

  const { spins } = useAuroraCrystalLogic();
  const { remains, total } = spins;

  const noSpins = remains === 0;

  const diamondSrc = noSpins ? diamond1 : diamond2;

  const message = useMemo(() => {
    if (!isAuthenticated) return t('crystal:nonAuthPanelTitle');
    if (noSpins) return t('crystal:noSpinsLeft', { total });
    return t('crystal:spinsLeft', { remains, total });
  }, [isAuthenticated, noSpins, total, remains, t]);

  return (
    <ScAuroraPanel
      onClick={() => {
        onLinkClick && onLinkClick();
        navigate('/lucky-wheel');
      }}
    >
      <ImageComponent alt="background" className="bg" fill src={menuBg} />
      <div className="inner">
        <div className="content">
          <ImageComponent
            alt="diamond"
            className="crystal mobile"
            height={24}
            src={diamondSrc}
            width={38}
          />
          <div className="content-text">
            <div className="title">
              <p>Aurora Crystals</p>
              <ImageComponent
                alt="diamond"
                className="crystal desktop"
                height={14}
                src={diamondSrc}
                width={22}
              />
            </div>
            <p className="spins-left">{message}</p>
          </div>
        </div>
        <div className="mobile">
          <images.arrowRightSmallIcon.component />
        </div>
      </div>
    </ScAuroraPanel>
  );
});
